import { categoriasDB } from './index'

const DEFAULTS = [
  { nombre: 'Bebidas',   emoji: '🥤' },
  { nombre: 'Botanas',   emoji: '🥔' },
  { nombre: 'Panadería', emoji: '🍞' },
  { nombre: 'Lácteos',   emoji: '🥛' },
  { nombre: 'Frescos',   emoji: '🥚' },
  { nombre: 'Limpieza',  emoji: '🧼' },
  { nombre: 'Enlatados', emoji: '🫘' },
  { nombre: 'Dulces',    emoji: '🍭' },
  { nombre: 'Cigarros',  emoji: '🚬' },
  { nombre: 'Otro',      emoji: '📦' },
]

export async function obtenerCategorias() {
  const result = await categoriasDB.allDocs({ include_docs: true })
  const cats = result.rows.map(r => r.doc).filter(d => !d._id.startsWith('_design'))
  if (cats.length === 0) {
    await seedCategorias()
    return obtenerCategorias()
  }
  return cats.sort((a, b) => a.nombre.localeCompare(b.nombre))
}

async function seedCategorias() {
  for (const cat of DEFAULTS) {
    const id = `cat_${cat.nombre.toLowerCase().replace(/[^a-z0-9]/g, '_')}`
    await categoriasDB.put({ _id: id, ...cat })
  }
}

export async function guardarCategoria(categoria) {
  if (categoria._id) return categoriasDB.put(categoria)
  const id = `cat_${Date.now()}`
  return categoriasDB.put({ _id: id, ...categoria })
}

export async function eliminarCategoria(categoria) {
  return categoriasDB.remove(categoria)
}

export async function obtenerOCrearCategoria(nombre, emoji = '📦') {
  const todas = await obtenerCategorias()
  const existente = todas.find(c => c.nombre.toLowerCase() === nombre.toLowerCase())
  if (existente) return existente.nombre
  await guardarCategoria({ nombre, emoji })
  return nombre
}
